import $ from 'jquery';

export default function removeNovalidate () {
    $('#commentform').removeAttr('novalidate');
}